module.exports = __webpack_public_path__ + "static_pc/img/marquee1.688b7c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/marquee1.jpg
// module id = 1Ug4
// module chunks = 1